module.exports = __webpack_public_path__ + "media/img/seed/4-d6e5821bea14473f5d53cffe44661858.jpeg";